import { render, staticRenderFns } from "./OngletNegoce.vue?vue&type=template&id=853a8cf4"
import script from "./OngletNegoce.vue?vue&type=script&lang=js"
export * from "./OngletNegoce.vue?vue&type=script&lang=js"
import style0 from "./OngletNegoce.vue?vue&type=style&index=0&id=853a8cf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports